import { Injectable } from '@angular/core';
import {Form} from '../../classes/Form';

@Injectable({
  providedIn: 'root'
})
export class RegisterFormService {

  private static FORM = 'FORM';
  private static REG_FORM = 'REG_FORM';

  private _form: Form;
  private _regForm;

  constructor() { }


  get form(): Form {
    return this._form;
  }

  set form(value: Form) {
    this._form = value;
  }

  get regForm() {
    return this._regForm;
  }

  set regForm(value) {
    this._regForm = value;
  }
}
